module.exports = __webpack_public_path__ + "img/photos.94183b08.jpg";